/** Remove comma separators and parse a numeric prefix; return null for missing or unparseable input. */
export const safeParseFloat = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }

  const cleanedValue = value.replace(/,/g, "").trim();
  // ast-grep-ignore: no-unsafe-number-parsing
  const parsed = parseFloat(cleanedValue);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};

/** Remove comma separators and parse an integer prefix, truncating decimals; return null on failure. */
export const safeParseInt = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }

  const cleanedValue = value.replace(/,/g, "").trim();
  // ast-grep-ignore: no-unsafe-number-parsing
  const parsed = parseInt(cleanedValue);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};

/**
 * Parse a hexadecimal integer prefix using radix 16.
 * Trim surrounding whitespace; return null for missing or unparseable input.
 */
export function safeParseHexInt(value: string | null | undefined): number | null {
  if (!value) return null;

  const parsed = parseInt(value.trim(), 16);

  return Number.isNaN(parsed) ? null : parsed;
}
